/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * Current state for smart pay as you go
 */
export type SmartPayAsYouGoState =
  (typeof SmartPayAsYouGoState)[keyof typeof SmartPayAsYouGoState]

export const SmartPayAsYouGoState = {
  off: "off",
  on: "on",
  pending: "pending",
  partial: "partial",
  not_eligible: "not_eligible",
} as const
